import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

export const useStyles = makeStyles(() => createStyles({
  projectOverviewActions: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    '& .title': {
      fontSize: '24px',
      fontWeight: '500',
      lineHeight: '28px',
    },
    '& .list': {
      display: 'flex',
      gap: '16px',
    },
  },
}));
